export default ({ provider, consentUrl = '/resourcerer-rich-text/embed-consent' }) => ({
  provider,
  consentUrl,
  consented: false,
  remember: false,

  get storageKey() {
    return `resourcerer-rich-text:embed-consent:${this.provider}`
  },

  init() {
    try {
      if (window.localStorage.getItem(this.storageKey) === '1') {
        this.consented = true
        this.stamp()
      }
    } catch {
      // localStorage unavailable (e.g. blocked) - consent stays per view
    }
  },

  consent() {
    if (this.remember) {
      try {
        window.localStorage.setItem(this.storageKey, '1')
      } catch {
        // ignore
      }

      this.persistServerSide()
    }

    this.consented = true
    this.stamp()
  },

  stamp() {
    this.$nextTick(() => {
      const target = this.$refs.target

      if (target && !target.hasChildNodes()) {
        target.appendChild(this.$refs.frame.content.cloneNode(true))
      }
    })
  },

  persistServerSide() {
    // No endpoint configured (route disabled and no consent.url) - consent
    // stays client-side (localStorage) only, no server round-trip.
    if (!this.consentUrl) {
      return
    }

    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.consentUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...(token ? { 'X-CSRF-TOKEN': token } : {}),
      },
      body: JSON.stringify({ provider: this.provider }),
    }).catch(() => {
      // consent stays client side only
    })
  },
})
